import { GridItem } from "@octopus-energy/coral/atoms"
import { StoryblokMissingField } from "@octopus-energy/coral/storyblok"
import { StoryblokComponent } from "@storyblok/react"
import { type SbBlokGridItem } from "../types"

interface DynamicGridItemProps {
    blok: SbBlokGridItem
}

function formatSpan(span: number) {
    return `span ${span}` as const
}

export function DynamicGridItem({
    blok: { blocks, colSpan, colSpanMedium, colSpanSmall, rowSpan, rowSpanMedium, rowSpanSmall },
}: DynamicGridItemProps) {
    if (!blocks?.length) {
        return (
            <StoryblokMissingField
                blok="Grid Item"
                field="Blocks"
            />
        )
    }

    return (
        <GridItem
            gridColumn={{
                base: colSpanSmall ? formatSpan(colSpanSmall) : undefined,
                md: colSpanMedium ? formatSpan(colSpanMedium) : undefined,
                lg: colSpan ? formatSpan(colSpan) : undefined,
            }}
            gridRow={{
                base: rowSpanSmall ? formatSpan(rowSpanSmall) : undefined,
                md: rowSpanMedium ? formatSpan(rowSpanMedium) : undefined,
                lg: rowSpan ? formatSpan(rowSpan) : undefined,
            }}
        >
            {blocks.map((nestedBlok) => (
                <StoryblokComponent
                    blok={nestedBlok}
                    key={nestedBlok._uid}
                />
            ))}
        </GridItem>
    )
}

export default DynamicGridItem
